var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section reserves"},[_c('h2',{staticClass:"section__title"},[_vm._v("Резервы")]),_c('data-table',{ref:"table",attrs:{"options":_vm.tableOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }